import {formatTime, msToReadableTime} from "./util";

//Date,Datetime,Time formatter
const formatTimeStampCellValue = (timestamp: any, type: string) => {
  return type === "Time" && Array.isArray(timestamp)
    ? timestamp.map((ts: any) => formatTimestamp(ts, type)).join(" , ")
    : formatTimestamp(timestamp, type);
};
const formatTimestamp = (timestamp: string | number, type: string) => {
  const date = new Date(Number(timestamp));
  if (isNaN(date.getTime())) {
    return "-";
  }

  if (type === "DateTimeSeconds") {
    return formatDateTimeWithSeconds(date);
  }

  return new Intl.DateTimeFormat("en-GB", {
    ...(type === "Date" && {
      day: "2-digit",
      month: "short",
      year: "numeric"
    }),
    ...(type === "Datetime" && {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    }),
    ...(type === "Time" && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    })
  }).format(date);
};
// IVMS/IDMS Trip Report
const formatDateTimeWithSeconds = (date: Date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

//SwipeLocations formatter
const formatSwipeLocationValue = (swipeLocation: any[]) => {
  if (!Array.isArray(swipeLocation)) return "";

  return swipeLocation
    .map((item: any) => {
      if (!item?.swipe || !item?.location) return "";
      return formatTime(item.swipe);
    })
    .filter(Boolean)
    .join(", ");
};
//SwipeTimings formatter
const formatSwipeVehicleTimingValue = (swipeLocation: any[]) => {
  if (!Array.isArray(swipeLocation)) return "";

  return swipeLocation
    .map((entry: any) => {
      const times = entry.swipes?.length
        ? entry.swipes.map((t: number) => formatTime(t)).join(", ")
        : "No swipes";

      return `${entry.vehicle} (${times})`;
    })
    .join(" | ");
};

//Duration formatter
const formatDuration = (duration: number) => {
  return duration === 0 ? "0 Min" : `${msToReadableTime(duration)}`;
};

//Location formatter
const formatLocation = (latLngs: any) => {
  return Array.isArray(latLngs)
    ? latLngs.length > 1
      ? // Multiple points Used Google Maps Directions URL LIKE (https://www.google.com/maps/dir/)
        (() => {
          return latLngs.map((latLng: string) => latLng.trim()).join(",");
        })()
      : // Single point Google Maps URL LIKE (https://www.google.com/maps/search/?api=1&query=lat,lng)
        // ["latLLng"] If latLngs is an array with a single value, we can still use the same logic
        latLngs.map((latLng: string, index: number) => {
          latLng = latLng.trim();
          return `${latLng} `;
        })
    : (() => {
        return latLngs.trim();
      })();
};

//Attendance formatter
const formatAttendance = (attendance: string) => {
  const isPresent = attendance?.toLowerCase() === "present";
  return isPresent;
};

//tripType formatter
const formatTripType = (tripType: string) => {
  const isPickup =
    tripType === "Onward" || tripType === "Pickup" || tripType == "0";
  return isPickup;
};

//Yes No Options formatter
const formatYesNoOptions = (value: any) => {
  const booleanValue =
    typeof value === "boolean" ? (value === true ? "Yes" : "No") : value === 1;
  return booleanValue;
};

// in dashboard fuel theft and refilling -lastRefillDate,theftDate,recentFillDate

const fuelDateColumnUids = new Set([
  "lastRefillDate",
  "theftDate",
  "recentFillDate"
]);

const formatFuelDateTime = (value: any) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === 0 ||
    value === "0"
  ) {
    return "";
  }

  const textValue = String(value).trim();
  const date = new Date(
    /^\d+$/.test(textValue) ? Number(textValue) : textValue
  );

  if (isNaN(date.getTime())) {
    return "";
  }

  const datePart = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short"
  }).format(date);

  const timePart = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  }).format(date);

  return `${datePart}, ${timePart}`;
};
export const formatCellValue = {
  formatTimeStampCellValue,
  formatTimestamp,
  formatSwipeLocationValue,
  formatSwipeVehicleTimingValue,
  formatDuration,
  formatLocation,
  formatAttendance,
  formatTripType,
  formatYesNoOptions,
  formatFuelDateTime,
  fuelDateColumnUids
};
